import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Navbar from "../../components/common/Navbar";

import MTImage from "../../assets/images/webview.gif";
import { useStyles } from "../../assets/styles/Theme";
import { LOGIN_API_2 } from "../../api/ApiModel";
import { setUserParams } from "../../store/ReduxUser";
import { externalpostApi } from "../../services/external/externalApis";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { CON_MODULE_SYSADMIN } from "../../utils/sys/Constants";
import { setAccessRights } from "../../store/ReduxAccessRight";
import { setAccessModules } from "../../store/ReduxAccessModules";
import { setCashierUserRefCode } from "../../store/ReduxCashierCartReducer";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { LOGIN_FAILED, LOGIN_SUCCESS } from "../../utils/sys/Messages";

function ModuleTransfer() {
  const theme = useTheme();
  const navigate = useNavigate();
  const styles = useStyles(theme);
  // const [username, setUsername] = useState("");
  // const [tempkey, setTempkey] = useState("");
  // const [modulecode, setModulecode] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  // Timer for redirection
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const username = params.get("username");
    const tempkey = params.get("tempkey");
    const modulecode = params.get("modulecode");

    console.log("tempkey", tempkey);
    if (username && tempkey && modulecode) {
      handleTransferLogin(username, tempkey, modulecode);
    } else {
      setError("Missing parameters in the URL.");
      setSnackbarMessage(LOGIN_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }

    // Redirect after 5 minutes as a fallback
    const timer = setTimeout(() => {
      navigate("/home");
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, [navigate]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleTransferLogin = async (username, tempkey, modulecode) => {
    try {
      const loginResponse = await externalpostApi(LOGIN_API_2, {
        username,
        tempkey,
        modulecode,
      });
      const userData = loginResponse.user;
      const accessRightsData = loginResponse.accessRights;
      const accessModulesData = loginResponse.accessModules;

      console.log("loginResponse", loginResponse);
      // Dispatch user data and access rights to redux
      dispatch(setUserParams(userData));
      dispatch(setAccessRights(accessRightsData)); // Dispatch access rights
      dispatch(setAccessModules(accessModulesData));
      setSnackbarMessage(LOGIN_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      navigate("/home", {
        state: { snackbarMessage: LOGIN_SUCCESS, snackbarSeverity: "success" },
      });
    } catch (error) {
      console.error("Login failed:", error);
      setError("Login failed. Please check your credentials and try again.");
      setSnackbarMessage(LOGIN_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      <Box
        // mt={20}
        // ml={18}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: theme.palette.background.default,
        }}
      >
        <Grid
          container
          spacing={4}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{
            height: "80vh",
            overflowY: "auto",
            bgcolor: theme.palette.background.paper,
            borderRadius: "8px",
            boxShadow: 3,
            p: 3,
            transition: "box-shadow 0.3s",
            "&:hover": { boxShadow: 6 },
            background: `linear-gradient(135deg, ${theme.palette.background.default} 30%, ${theme.palette.background.paper} 100%)`,
          }}
        >
          {/* GIF Image */}

          <Box
            component="img"
            src={MTImage}
            alt="Point of Order System"
            sx={{
              ...styles.img_login_card,
              width: "300px",
              height: "300px",
              borderRadius: "8px",
              boxShadow: 3,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontWeight: "bold",
              color: theme.palette.text.primary,
            }}
          ></Typography>
          <Typography
            variant="subtitle1"
            color={theme.palette.text.secondary}
            sx={{ textAlign: "center" }}
          >
            Please wait, redirecting you soon...
          </Typography>
        </Grid>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </>
  );
}

export default ModuleTransfer;
